/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import PropTypes from "prop-types";

import "./style.css";

import { DisableMenu } from "./../utilities";

class DropdownMenu extends Component {
  handleClick = () => {
    DisableMenu();
    if (this.props.metaData.onClick !== undefined) {
      this.props.metaData.onClick();
    }
    document.getElementById(this.props.metaData.id).classList.toggle("show");
  };

  render() {
    const { metaData } = this.props;
    if (Object.keys(metaData).length > 0)
      return (
        <div className={"dropdown " + metaData.dropdown}>
          <button
            onClick={this.handleClick}
            className={"dropbtn no-click " + metaData.dropbtn}
          >
            {metaData.text}
          </button>
          <div
            id={metaData.id}
            className={"dropdown-content " + metaData.dropdownContent}
          >
            {metaData.items.map((val, item) => {
              return (
                <a
                  href="#"
                  onClick={val.func}
                  key={`item-menu-${metaData.id}-${item}`}
                  className={val.classNames}
                >
                  {val.text}
                </a>
                // <a
                //   href="#"
                //   onClick={val.func}
                //   key={`item-menu-${metaData.id}-${item}`}
                //   className={val.classNames}
                // >
                //   {val.text}
                // </a>
              );
            })}
          </div>
        </div>
      );
    return <></>;
  }
}

DropdownMenu.propTypes = {
  metaData: PropTypes.object.isRequired
};

export default DropdownMenu;
